<template>
  <van-popover
    theme="dark"
    :value="showPopover"
    @input="closePopover"
    trigger="click"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #default>
      <div
        class="content"
        :style="{ maxWidth: maxW, 'max-height': tipPopoverHeight + 'px' }"
      >
        <template v-if="!Array.isArray(tipWord)">
          {{ tipWord }}
        </template>
        <template v-else>
          <div v-for="(i, index) in tipWord" :key="index">{{ i }}</div>
        </template>
      </div>
    </template>
    <template #reference>
      <van-icon name="info" class="gray" />
    </template>
  </van-popover>
</template>

<script>
export default {
  name: 'TipPop',
  props: {
    tipWord: {
      type: [String, Array],
      default: '',
    },
    maxW: {
      type: String,
      default: '33.33vw',
    },
    tipPopoverHeight: {
      type: [String, Number],
      default: 'auto',
    },
  },
  components: {},
  data() {
    return {
      showPopover: false,
    }
  },
  methods: {
    show() {
      this.showPopover = true
    },
    closePopover() {
      this.showPopover = false
    },
  },
}
</script>

<style scoped lang="scss">
.content {
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  overflow: auto;
  padding: 10px;
  font-weight: 400;
  font-size: 14px;
  font-size: var(--set-font-size14);
  color: #ffffff;
  line-height: 22px;
}
.gray {
  color: #dedfe5;
}
</style>
